// extracted by mini-css-extract-plugin
module.exports = {"card":"actor_card__2BMLT","link":"actor_link__2VWt1","image":"actor_image__1LDhV","info":"actor_info__276k4","name":"actor_name__38j6_","character":"actor_character__2zFIO"};